// extracted by css-extract-rspack-plugin
export default {"keyValue":"ScimApiKeysTable_keyValue__b-aIP"};